import BaseStore from "./BaseStore";

export default class SignUpPrompt extends BaseStore {
    module = ['SignUpPrompt'];

    showPrompt(payload = true) {
        this.commit('showPrompt', payload);
    }

    getShowPrompt() {
        return this.state('showPrompt');
    }
}
